import React from 'react';

import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { MultiSelect } from '@/modules/common/components/molecules/selectors/multiselect';
import { ALL_SERVICES } from '@/modules/common/types/organization-services';

import { OrganizationFormValues } from '../schemas/organization-schema';

interface ServicesSelectorProps {
  control: Control<OrganizationFormValues>;
}

export const ServicesSelector: React.FC<ServicesSelectorProps> = ({ control }) => {
  const { t } = useTranslation(['authenticated.organization']);

  return (
    <FormField
      control={control}
      name="services"
      render={({ field }) => (
        <FormItem className="min-w-0 flex-1 basis-0">
          <FormLabel>{t('authenticated.organization:fields.services')}</FormLabel>
          <FormControl>
            <MultiSelect
              options={ALL_SERVICES.map(service => ({
                value: service,
                label: t(`authenticated.organization:services.${service}`),
              }))}
              onValueChange={values => field.onChange(values)}
              defaultValue={field.value || []}
              isSelectAllButtonVisible={false}
              isApplyButtonVisible={true}
              placeholder={t('authenticated.organization:placeholders.services')}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
